import axios from "axios";
import jwt_decode from "jwt-decode";

const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = token;
    const decoded = jwt_decode(token);
    if (decoded?.bsp) {
      axios.defaults.headers.common["x-tenant-id"] = decoded.id;
    }
  } else {
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["x-tenant-id"];
  }
};

export default setAuthToken;
